import RestApi from '@utilities/RestApi'
import Axios from 'axios'

import MonitoringApiClient from '@modules/admin/monitoring/monitoring.api'
import { AnalyticsApi } from '@modules/admin/analytics/analytics.Api'

class ProfessionalSingleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_PROFESSIONAL,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance base URL is ${this.client.defaults.baseURL}`)

    // this.client.interceptors.request.use(refreshTokenInterceptor);

    // IMPLEMENTATIONS

    this.professional = new RestApi(this.client, '/admin/v1/professionals')

    // CHAT SIDEBAR
    this.automaticTrackings = new RestApi(this.client, 'api/automaticTracking')

    // ADMIN (ALMOST) STATIC INFO
    /*Todo: delete this endpoints when replace by news*/
    this.sentence = new RestApi(this.client, '/api/sentences')
    this.speciality = new RestApi(this.client, '/api/specialities')
    this.company = new RestApi(this.client, '/api/companies')
    this.monitoring = new MonitoringApiClient(this.client)

    this.provider = new RestApi(this.client, '/api/providers')

    this.appRole = new RestApi(this.client, '/api/appRoles')
    this.role = new RestApi(this.client, '/api/roles')

    //ANALYTICS
    this.analytics = new AnalyticsApi(this.client)

    this.reviews = new RestApi(this.client, '/api/reviews')
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const Professional = ProfessionalSingleton.instance
export default Professional
